import {
  ATTACHMENT_TYPE,
  ATTACHMENT_ACTIVITY_TYPE,
  DOWNLOAD_ATTACHMENT_STATUS,
  DOWNLOAD_ATTACHMENT_STATUS_CONFIG,
  DOWNLOAD_ATTACHMENT_ACTION_CONFIG,
} from './constants'

export const normalizeDownloadAttachmentList = (payload) => {
  if (Array.isArray(payload)) return payload
  if (Array.isArray(payload?.data)) return payload.data
  return []
}

export const getDownloadAttachmentActivityType = (name = '') => {
  const attachmentName = name.trim().toUpperCase()

  if (attachmentName.startsWith(ATTACHMENT_TYPE.POP)) return ATTACHMENT_ACTIVITY_TYPE.POP
  if (attachmentName.startsWith(ATTACHMENT_TYPE.POD)) return ATTACHMENT_ACTIVITY_TYPE.POD

  return ''
}

export const getDownloadPhotoStatusConfig = (statusKey) =>
  DOWNLOAD_ATTACHMENT_STATUS_CONFIG[statusKey] ||
  DOWNLOAD_ATTACHMENT_STATUS_CONFIG[DOWNLOAD_ATTACHMENT_STATUS.NOT_REQUESTED]

export const getDownloadPhotoActionConfig = (statusKey) =>
  DOWNLOAD_ATTACHMENT_ACTION_CONFIG[statusKey] ||
  DOWNLOAD_ATTACHMENT_ACTION_CONFIG[DOWNLOAD_ATTACHMENT_STATUS.NOT_REQUESTED]

export const mapToTableItem = (item, translate) => {
  const statusConfig = getDownloadPhotoStatusConfig(item.status)
  const actionConfig = getDownloadPhotoActionConfig(item.status)
  const fileName = item.fileName || item.name

  return {
    fileName,
    statusKey: item.status,
    status: translate(statusConfig.label),
    color: statusConfig.color,
    action: translate(actionConfig.label),
    actionIcon: actionConfig.icon,
    url: item.url,
    activityType: item.activityType || getDownloadAttachmentActivityType(fileName),
  }
}
